import { authApi } from 'src/api/authApi';
import type { AuthTokens } from './authTokens';

let inFlightRefresh: Promise<AuthTokens> | null = null;

/**
 * Refresh access token using the stored refresh token.
 * Concurrent callers share one in-flight request (single-flight).
 */
export const refreshAuthSession = async (): Promise<AuthTokens> => {
  const storedRefreshToken = localStorage.getItem('refreshToken');

  if (!storedRefreshToken) {
    throw new Error('NO_REFRESH_TOKEN');
  }

  if (!inFlightRefresh) {
    inFlightRefresh = authApi.refreshSession(storedRefreshToken).finally(() => {
      inFlightRefresh = null;
    });
  }

  return inFlightRefresh;
};

export const resetRefreshSessionFlight = (): void => {
  inFlightRefresh = null;
};
